import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'quill/dist/quill.snow.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function Editor({
    onChange,
    value,
    className,
    description,
    title,
    ...props
}) {
    const { t } = useTranslation();

    const formats = [
        'bold',
        'italic',
        'underline',
        'strike',
        'align',
        'list',
        'indent',
        'link',
        'clean',
        'header',
    ];

    let modules = {
        toolbar: [['bold', 'italic', 'underline'], ['link'], ['clean']],
        keyboard: true,
    };

    if (description) {
        modules = {
            toolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link'],
                ['clean'],
            ],
            keyboard: true,
        };
    }

    if (title) {
        modules = {
            toolbar: [
                [{ header: [2] }],
                ['bold', 'italic', 'underline'],
                [{ align: ['center'] }],
                ['link'],
                ['clean'],
            ],
            keyboard: true,
        };
    }

    if (props?.hideToolbar) {
        modules = {
            toolbar: false,
            keyboard: true,
        };
    }

    const placeholder = props?.placeholder ?? t('PleaseSpecifyDetail');

    const triggerChange = (changedValue) => {
        if (['', '<p><br></p>'].includes(changedValue)) onChange?.('');
        else onChange?.(changedValue);
    };

    return (
        <div className={classNames(className)}>
            <ReactQuill
                theme="snow"
                defaultValue={value}
                onChange={triggerChange}
                value={value}
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                className="ql-editor-custom"
                readOnly={props?.readOnly || false}
            />
        </div>
    );
}

Editor.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    className: PropTypes.string,
    description: PropTypes.bool,
    title: PropTypes.bool,
    props: PropTypes.object,
};
